/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useContext } from "react";
import Purchases from "components/Purchases";
import { AuthContext } from "components/Auth";
import { StoreContext } from "components/StoreContext";
import { CartContext } from "components/CartContext";
import HeadTags from "components/HeadTags";
import ServerError from "containers/Error/components/serverError";
import Loading from "components/Loading";
import SignIn from "./SignIn";
import NoPurchases from "./NoPurchases";

const PurchaseHistory = () => {
  const { store, StoreAPI, config } = useContext(StoreContext);
  const { customer } = useContext(CartContext);
  const { authorized, signIn } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [purchases, setPurchases] = useState([]);
  useEffect(() => {
    if (store.loaded && customer.znodeUserId) {
      setLoading(true);
      StoreAPI.get("orders", {
        params: {
          userid: customer.znodeUserId
        }
      })
        .then(response => {
          setLoading(false);
          setError(null);
          setPurchases(response.data);
        })
        .catch(response => {
          setLoading(false);
          setError(response.response.status);
        });
    }
  }, [
    store.loaded,
    customer.znodeUserId,
    StoreAPI,
    error,
    customer.hStreamId,
    authorized,
    config.accessCourseLink
  ]);

  return !loading ? (
    <>
      <HeadTags title="Purchase History" />
      {error >= 400 && error <= 499 ? (
        <div className="purchases__content">
          <NoPurchases error={error} />
        </div>
      ) : error >= 500 ? (
        <ServerError errorCode={error} />
      ) : purchases.length > 0 ? (
        <div className="purchases__content">
          <Purchases
            purchases={purchases}
            loading={loading}
            accessCourseLink={config.accessCourseLink}
            accessFreeCourseLink={config.accessFreeCourseLink}
          />
        </div>
      ) : (
        <div className="purchases__content">
          {!authorized && <SignIn signIn={signIn} loading={loading} />}
        </div>
      )}
    </>
  ) : (
    <div className="purchases__content">
      <HeadTags title="Purchase History" />
      <Loading bg="transparent" />
    </div>
  );
};

export default PurchaseHistory;
